import { render, staticRenderFns } from "./PaymentTables.vue?vue&type=template&id=522665ae&scoped=true&"
import script from "./PaymentTables.vue?vue&type=script&lang=js&"
export * from "./PaymentTables.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTables.vue?vue&type=style&index=0&id=522665ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522665ae",
  null
  
)

export default component.exports